import React, {Component} from 'react';
import './SearchDropdown.css';
import PositionAligner from './PositionAligner';
import createPauser from '../pauser';

const getHighlightedItem = (state, props, highlighted) =>
	state &&
	state.resultItems &&
	props &&
	props.keyFunc &&
	state.resultItems.find(item => highlighted === props.keyFunc(item));

class SearchDropdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shown: props.initiallyShown || false,
			valueBuffer: props.value,
			highlighted: null,
			resultItems: null,
			waitingForData: false
		};

		this.show = () => {
			this.setState({shown: true, resultItems: null, valueBuffer: ''});
		};

		this.hide = () => {
			this.setState({shown: false});
		};

		this.onSelect = highlighted => {
			this.props.onSelect &&
				this.props.onSelect(highlighted, getHighlightedItem(this.state, this.props, highlighted));
			this.setState({shown: false});
		};

		this.clickOut = e => {
			if (
				this.el &&
				e.target !== this.input &&
				!this.el.contains(e.target) &&
				this.el !== e.target
			) {
				this.setState({shown: false, valueBuffer: this.props.value});
				if (this.props.onBlur) this.props.onBlur();
			}
		};

		this.getData = async () => {
			if (this.props.onSearch && !this.state.waitingForData) {
				if (this.state.valueBuffer) {
					this.setState({resultItems: null, waitingForData: true});
					const resultItems = await this.props.onSearch(this.state.valueBuffer);

					this.setState({resultItems, waitingForData: false});
				} else {
					this.setState({resultItems: null, waitingForData: false});
				}
				// TODO handle pagination?
			}
		};

		const resetPause = createPauser(this.getData, 500);

		this.updateBuffer = e => {
			this.setState({valueBuffer: e.target.value});
			resetPause();
		};

		this.itemOver = value => {
			this.setState({highlighted: value});
		};

		this.itemOut = value => {
			if (this.state.highlighted === value) {
				this.setState({highlighted: null});
			}
		};

		this.handleKeyPress = e => {
			if ((e.key === 'Enter' || e.key === 'Tab') && this.state.highlighted) {
				if (this.props.onSelect)
					this.props.onSelect(
						this.state.highlighted,
						getHighlightedItem(this.state, this.props, this.state.highlighted)
					);
				this.hide();
			} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				if (this.state.shown && this.state.resultItems) {
					let highlighted;
					let change = e.key === 'ArrowDown' ? 1 : -1;

					let items = this.state.resultItems;

					e.preventDefault(); // Prevent arrow navigation within input

					if (this.state.highlighted) {
						let currentIndex = items.findIndex(
							item => this.props.keyFunc(item) === this.state.highlighted
						);
						currentIndex += change;
						currentIndex =
							currentIndex >= items.length ? 0 : currentIndex < 0 ? items.length - 1 : currentIndex;
						highlighted = items[currentIndex] || null;
						highlighted = highlighted && this.props.keyFunc(highlighted);
					} else {
						highlighted = items[0] || null;
						highlighted = highlighted && this.props.keyFunc(highlighted);
					}

					this.setState({highlighted});
				} else {
					this.show();
				}
			}
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			// Buffer always overridden by prop value
			this.setState({valueBuffer: nextProps.value || null, resultItems: null});
		}
	}

	componentDidMount() {
		document.body.addEventListener('click', this.clickOut);
		if (this.props.initiallyShown) {
			this.input.focus();
			this.input.select();
		}
	}

	componentWillUnmount() {
		document.body.removeEventListener('click', this.clickOut);
	}

	render() {
		const {
			className,
			wrapperClassName = '',
			extra,
			allowNull = false,
			itemRenderer,
			placeholder,
			onShowMore,
			scrollInOnShow,
			emptyMessage = 'Waiting...'
		} = this.props;
		const {shown, valueBuffer, resultItems, highlighted, waitingForData} = this.state;

		return (
			<div
				className={`SearchDropdown ${className || ''} ${shown ? 'shown' : ''}`}
				ref={el => (this.el = el)}>
				<div className="SearchDropdown-selection" tabIndex={1}>
					<input
						className="SearchDropdown-input"
						value={valueBuffer || ''}
						onChange={this.updateBuffer}
						onKeyDown={this.handleKeyPress}
						ref={el => (this.input = el)}
						onFocus={this.show}
						onBlur={this.hide}
						placeholder={placeholder}
						type="search"
					/>
					{extra && <div className="SearchDropdown-extra">{extra}</div>}
				</div>
				<div>
					<ol className="SearchDropdown-values">
						{allowNull && (
							<DropdownItem
								key={'null'}
								isHighlighted={!highlighted}
								onClick={this.onSelect}
								onMouseOver={this.itemOver}
								onMouseOut={this.itemOut}
								value={null}
								label="(No selection)"
							/>
						)}
						{resultItems &&
							resultItems.map(item => (
								<DropdownItem
									key={this.props.keyFunc(item)}
									{...item}
									isHighlighted={highlighted === this.props.keyFunc(item)}
									keyFunc={this.props.keyFunc}
									onClick={this.onSelect}
									onMouseOver={this.itemOver}
									onMouseOut={this.itemOut}
									itemRenderer={itemRenderer}
								/>
							))}
						{resultItems && resultItems.length && onShowMore ? (
							<div
								className="SearchDropdown-more"
								onMouseDown={() => onShowMore(valueBuffer || '')}>
								Show more...
							</div>
						) : (
							undefined
						)}
						{resultItems && !resultItems.length && (
							<div className="SearchDropdown-empty">No items found</div>
						)}
						{waitingForData ? <div className="SearchDropdown-empty">Searching...</div> : undefined}
						{/* {!resultItems && !waitingForData && valueBuffer ? (
							<div className="SearchDropdown-empty">{emptyMessage}</div>
						) : (
							undefined
						)} */}
					</ol>
				</div>
			</div>
		);
	}
}

class DropdownItem extends Component {
	constructor() {
		super();
		this.handleClick = () => {
			if (this.props.onClick) this.props.onClick(this.props.keyFunc(this.props));
		};
		this.mouseOver = () => this.props.onMouseOver(this.props.keyFunc(this.props));
		this.mouseOut = () => this.props.onMouseOut(this.props.keyFunc(this.props));
	}

	render() {
		const {label, extra, isHighlighted, itemRenderer} = this.props;

		return itemRenderer ? (
			itemRenderer(this.props)
		) : (
			<li
				className={`SearchDropdown-item ${isHighlighted ? 'highlighted' : ''}`}
				onMouseDown={this.handleClick}
				onMouseOver={this.mouseOver}
				onMouseOut={this.mouseOut}>
				<div className="Dropdown-name">{label}</div>
				<div className="Dropdown-extra">{extra}</div>
			</li>
		);
	}
}

export default SearchDropdown;



// WEBPACK FOOTER //
// ./src/widgets/SearchDropdown.js